import gsap, {Linear} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import initScrollTrigger from '../helpers/initScrollTrigger';
import {debounce} from 'throttle-debounce';

import {initlocalLazyScrollAutoplay} from '../components/video';

import сustomPageScroll from './custom-scroll';

import {IS_TOUCH, IS_PHONE, BREAKPOINTS, CLASSES} from '../helpers/consts';

gsap.registerPlugin(ScrollTrigger);

export function calculateCathetus(cathetus, angle) {
	// Конвертуємо градуси в радіани
	const radians = (angle * Math.PI) / 180;

	// Обчислюємо довжину гіпотенузи
	const hypotenuse = cathetus / Math.cos(radians);

	// Обчислюємо довжину другого катету
	const otherCathetus = Math.sqrt(Math.pow(hypotenuse, 2) - Math.pow(cathetus, 2));

	return otherCathetus;
}

const initVideos = (section) => {
	const mediaVideos = [...section.querySelectorAll('.js-about-social-video')];
	console.log('initVideos')
	initlocalLazyScrollAutoplay(mediaVideos, {
		ratio: '9:16',
		muted: true,
		controls: [],
		autoplay: false,
	});

};


export default () => {
	const section = document.querySelector('.js-social-section');
	if(!section) return;

	initScrollTrigger();
	if(IS_PHONE) {
		initVideos(section);
		return;
	}

	const wrapper = section.querySelector('.js-social-section-inner');
	const fixedBlock = section.querySelector('.js-social-section-fixed-block');
	const scrollBlock = section.querySelector('.js-social-section-scroll-block');
	const scrollBlockInner = section.querySelector('.js-social-section-scroll-block-inner');
	// console.log(wrapper, fixedBlock);

	initVideos(section);


	const angle = 5;
	const transformOrigin = '100% 50%';

	const trigger = ScrollTrigger.create({
		trigger: wrapper,
		pin: fixedBlock,
		pinSpacing: true,
		start: 'top top',
		end: 'bottom bottom',
		onLeave: () => {
			console.log('onLeave');
		}
	});

	ScrollTrigger.saveStyles(scrollBlockInner);
	ScrollTrigger.matchMedia({

		// desktop
		'(min-width: 1024px)': function() {
			gsap.set(scrollBlockInner, {rotation: angle, transformOrigin: transformOrigin});

			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: wrapper,
					start: 'top top',
					end: 'bottom bottom',

					scrub: true,
				}
			})
				.to(scrollBlockInner, {
					duration: 1,
					x: () => {

						const wrapperWidth = scrollBlock.getBoundingClientRect().width;
						const wrapperHeight = scrollBlock.getBoundingClientRect().height;

						const innerWidth = scrollBlockInner.getBoundingClientRect().width;
						const innerHeight = scrollBlockInner.getBoundingClientRect().height;

						const res = wrapperHeight - innerHeight;

						const offset = calculateCathetus(innerHeight, angle);


						return offset/2 - res/2 - 20;
					},

					// y: () => {
					// 	const blockH = scrollBlockInner.getBoundingClientRect().height;
					// 	const wh = window.innerHeight;
					// 	// return	`-${blockH + wh}px`
					// 	return `-100%`
					// }, // Перемещаем блок вверх
					// x: '30%', // Перемещаем блок влево, чтобы компенсировать вращение
					// x: () => {
					// 	const res = innerWidth - wrapperWidth;
					// 	return `${res}px`;
					// },
					transformOrigin: transformOrigin,
					ease: 'linear'
				});

		},


		'all': function() {

		}

	});













	// if there are objects that may get inline styles added (like via tweens) that should get reverted, use ScrollTrigger.saveStyles() initially so that the current inline styles are saved for later reversion. It's not always necessary, but it goes well with ScrollTrigger.matchMedia() so we figured it'd make sense to show it here (it's not needed in this demo)
	// ScrollTrigger.saveStyles(".mobile, .desktop");

	/*** Different ScrollTrigger setups for various screen sizes (media queries) ***/




	//


	// const skewAngleInDegrees = 5;

	// const skewAngleInRadians = skewAngleInDegrees * Math.PI / 180;

	// const offset = innerHeight * Math.tan(skewAngleInRadians);
	// console.log(`offset`, offset);  // Це буде приблизно 34.92 пікселів

	// console.log(wrapperWidth, innerWidth);

	// gsap.set(scrollBlockInner, {skewX: skewAngleInDegrees, transformOrigin: '0% 50%'});
	// const tl = gsap.timeline({
	// 	scrollTrigger: {
	// 		trigger: section,
	// 		start: 'top top',
	// 		end: 'bottom bottom',
	// 		// scrub: 0.5,
	// 		// start: () => {
	// 		// 	return '-500px top'
	// 		// },
	// 		// end: () => {
	// 		// 	const sectionH = section.getBoundingClientRect().height;
	// 		// 	const wh = window.innerHeight;
	// 		// 	return `${sectionH + wh  + 500} bottom`
	// 		// },
	// 		markers: true,
	// 		scrub: true,
	// 	}
	// })
	// 	.to(scrollBlockInner, {
	// 		duration: 1,
	// 		skewX: skewAngleInDegrees,
	// 		x: -offset,
	// 		// y: () => {
	// 		// 	const blockH = scrollBlockInner.getBoundingClientRect().height;
	// 		// 	const wh = window.innerHeight;
	// 		// 	// return	`-${blockH + wh}px`
	// 		// 	return `-100%`
	// 		// }, // Перемещаем блок вверх
	// 		// x: '30%', // Перемещаем блок влево, чтобы компенсировать вращение
	// 		// x: () => {
	// 		// 	const res = innerWidth - wrapperWidth;
	// 		// 	return `${res}px`;
	// 		// },
	// 		transformOrigin: '50% 50%',
	// 		ease: 'linear'
	// 	});


	// const trigger = ScrollTrigger.create({
	// trigger: wrapper,
	// 	scrub: 0.5,
	// 	pin: fixedBlock,
	// 	pinSpacing: true,
	// 	start: 'top top',
	// 	end: 'bottom bottom',
	// 	markers: true,
	// 	onEnter: () => {
	// 		console.log(11)
	// 	}
	// });

	// const changescrollItems = (activeItem) => {
	// 	scrollItems.forEach((item) => {
	// 		item.classList.remove(CLASSES.active);
	// 	});
	// 	activeItem.classList.add(CLASSES.active);
	// };
	// mediaBlocks.forEach((mediaBlock, i) => {
	// 	const fixItem = scrollItems[i];

	// 	const blockColor = getComputedStyle(fixItem).getPropertyValue('--bg-color');
	// 	const prevBgColor =  i > 0 ? getComputedStyle(scrollItems[i - 1]).getPropertyValue('--bg-color'): false;

	// 	if(i === mediaBlocks.length - 1) {
	// 		bottomGradientEl.style.setProperty('--bottom-gradient-color', blockColor);
	// 	}

	// 	const trigger = ScrollTrigger.create({
	// 		trigger: mediaBlock,
	// 		start: 'top 50%',
	// 		end: 'bottom bottom',
	// 		// markers: true,
	// 		onEnter: () => {
	// 			console.log('onEnter');
	// 			globalBg.style.setProperty('--bg-section-color', blockColor);
	// 			globalBg.classList.add('is-changed-color');
	// 			changescrollItems(fixItem);

	// 		},
	// 		onEnterBack: () => {
	// 			console.log('onEnterBack');
	// 		},
	// 		onLeave: () => {
	// 			console.log('onLeave');
	// 		},
	// 		onLeaveBack: () => {
	// 			console.log('onLeaveBack');
	// 			if(prevBgColor) {
	// 				globalBg.style.setProperty('--bg-section-color', prevBgColor);
	// 			}
	// 			else {
	// 				console.log('onLeaveBack else');
	// 				globalBg.classList.remove('is-changed-color');
	// 				globalBg.style.setProperty('--bg-section-color', 'transparent');
	// 			}
	// 			if(i === 0) {
	// 				changescrollItems(scrollItems[0]);
	// 			}
	// 			else {
	// 				changescrollItems(scrollItems[i - 1]);
	// 			}
	// 		},
	// 	});
	// });




};
